import { PlayCircle, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "../components/Button";
import { SectionHeader } from "../components/SectionHeader";
import { SmartLink } from "../components/SmartLink";
import { brand } from "../config/brand";
import { navigateTo } from "../lib/navigation";

const recipes = [
  {
    title: "Bread Trials",
    image: "/assets/ig/0a4539a4952777fe.jpg",
    time: "2:15",
    summary: "A quick look at the bistro's pastry and bread testing."
  },
  {
    title: "Cocktail Notes",
    image: "/assets/site/cocktail.jpg",
    time: "1:08",
    summary: "Cocktail ideas for private dinners, brunch tables, and celebration nights."
  },
  {
    title: "Tuscan Salmon",
    image: "/assets/site/salmon-main.jpg",
    time: "2:46",
    summary: "A kitchen note on rich salmon, greens, and lemon herb butter."
  },
  {
    title: "Nigerian Meat Pie",
    image: "/assets/site/nigerian-meat-pie.jpg",
    time: "1:37",
    summary: "Chef OJ's flaky, spiced bistro take on a Nigerian classic."
  }
];

function readSearch() {
  return new URLSearchParams(window.location.search).get("search") ?? "";
}

export function RecipesPage() {
  const [search, setSearch] = useState(readSearch);
  const [selected, setSelected] = useState<(typeof recipes)[number] | null>(null);
  const searchTerm = search.trim().toLowerCase();
  const visibleRecipes = searchTerm
    ? recipes.filter((recipe) => [recipe.title, recipe.summary].join(" ").toLowerCase().includes(searchTerm))
    : recipes;

  useEffect(() => {
    const sync = () => setSearch(readSearch());
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  return (
    <main className="page-shell">
      <SectionHeader eyebrow="Straight from our kitchen" title="Recipes & Bistro Stories" centered level={1} />
      {visibleRecipes.length ? (
        <div className="story-grid" id="videos">
          {visibleRecipes.map((recipe) => (
            <button
              key={recipe.title}
              type="button"
              className="story-card"
              aria-label={`Open ${recipe.title}`}
              onClick={() => setSelected(recipe)}
            >
              <img src={recipe.image} alt={recipe.title} />
              <span>
                <PlayCircle />
              </span>
              <div>
                <p>{recipe.time}</p>
                <h3>{recipe.title}</h3>
              </div>
            </button>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <h2>No stories found</h2>
          <p>Browse the full recipe archive instead.</p>
          <Button onClick={() => navigateTo("/recipes")}>Clear search</Button>
        </div>
      )}
      {selected ? (
        <div className="story-modal" role="dialog" aria-modal="true" aria-labelledby="story-modal-title">
          <article>
            <button className="icon-button" type="button" aria-label="Close story" onClick={() => setSelected(null)}>
              <X size={20} />
            </button>
            <img src={selected.image} alt={selected.title} />
            <p className="eyebrow">{selected.time}</p>
            <h2 id="story-modal-title">{selected.title}</h2>
            <p>{selected.summary}</p>
            <SmartLink href={brand.instagramUrl} className="button button-dark">
              Open Instagram
            </SmartLink>
          </article>
        </div>
      ) : null}
    </main>
  );
}
